export enum StandardDraftsDraftStates {
    REQUESTED = 'REQUESTED',
    ASSIGNED = 'ASSIGNED',
    REJECTED = 'REJECTED',
    ACCEPTED = 'ACCEPTED',
}

export enum StandardDraftsDraftAction {
    REQUESTED = 'REQUEST',
    ASSIGNED = 'ASSIGN',
    REJECTED = 'REJECT',
    ACCEPTED = 'ACCEPT',
}

export enum PromiseStatus {
    FULFILLED = 'fulfilled',
    REJECTED = 'rejected',
}
